import { Button } from 'ui';
import PropTypes from 'prop-types';
import ReactAvatarEditor from 'react-avatar-editor';
import useCropImageFile from './useCropImageFile';

function CropImageFile({ file, isAvatar, isCalculateDimensions, onChange }) {
  const { borderRadius, height, rotate, scale, width, getImageCanva, handleZoomIn, handleZoomOut, setEditorRef, t } = useCropImageFile({
    file,
    isAvatar,
    isCalculateDimensions,
    onChange,
  });

  return (
    <div className="crop-image-file">
      <ReactAvatarEditor
        borderRadius={250 / (100 / borderRadius)}
        color={[140, 153, 173, 0.8]}
        height={height}
        image={file}
        onImageChange={getImageCanva}
        onImageReady={getImageCanva}
        ref={setEditorRef}
        rotate={rotate}
        scale={scale / 100}
        style={{ borderRadius: '6px', height: 380, width: 380 }}
        width={width}
      />

      <div className="crop-image-file__zoom">
        <Button variant="plain" isIconOnly leftIcon="zoom-out" ariaLabel={t('actions:Zoom out')} onClick={handleZoomOut} />

        <Button variant="plain" isIconOnly leftIcon="zoom-in" ariaLabel={t('actions:Zoom in')} onClick={handleZoomIn} />
      </div>
    </div>
  );
}

CropImageFile.propTypes = {
  file: PropTypes.object,
  isAvatar: PropTypes.bool,
  onChange: PropTypes.func,
};

export default CropImageFile;
